(()=>{
 const script=document.getElementById('wm-ui-click');
 const AudioContext=window.AudioContext||window.webkitAudioContext;
 if(!script||!AudioContext)return;
 const encoded=fetch(script.dataset.soundUrl).then(response=>{if(!response.ok)throw new Error('Click sound unavailable');return response.arrayBuffer()}).catch(()=>null);
 let context,bufferPromise;
 const active=new Set();
 async function click(){
  try{
   context||=new AudioContext();
   if(context.state==='suspended')await context.resume();
   bufferPromise||=encoded.then(data=>data?context.decodeAudioData(data):null);
   const buffer=await bufferPromise;
   if(!buffer||document.hidden)return;
   if(active.size>=6){const oldest=active.values().next().value;oldest.stop();active.delete(oldest)}
   const source=context.createBufferSource(),gain=context.createGain();
   source.buffer=buffer;gain.gain.value=.65;source.connect(gain);gain.connect(context.destination);
   active.add(source);source.onended=()=>{active.delete(source);source.disconnect();gain.disconnect()};source.start();
  }catch{}
 }
 document.addEventListener('click',event=>{
  if(!(event.target instanceof Element))return;
  const control=event.target.closest('button,a,input,summary,[role="button"],[role="tab"]');
  if(!control||control.matches(':disabled,[aria-disabled="true"]'))return;
  if(control.matches('.wm-buyers__play')||control.closest('.wm-showcase wm-suite-demo,.wm-showcase wm-showcase-clips'))click();
 },{capture:true});
})();
